(() => {
  const update = () => {
    document.querySelectorAll('.product-card').forEach(card => {
      const price = card.querySelector('.price');
      if (!price) return;
      const values = [...price.textContent.matchAll(/\$([\d,]+\.\d{2})/g)].map(m => Number(m[1].replace(/,/g, '')));
      if (values.length < 2 || values[1] <= values[0]) return;
      const savings = Math.round((1 - values[0] / values[1]) * 100);
      card.querySelectorAll('.badge--onsale').forEach(badge => { badge.textContent = `Save ${savings}%`; });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update, { once: true });
  else update();
  document.addEventListener('shopify:section:load', update);
})();
